import Vue from "vue";
import VueRouter from "vue-router";
// const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue');
import Home from "../views/Home.vue";
// import Help from "../views/Help.vue";
// const Help = () => import(/* webpackChunkName: "help" */ '../views/Help.vue');
// import Terms from "../views/Terms.vue";
// const Terms = () => import(/* webpackChunkName: "terms" */ '../views/Terms.vue');
// import PrivateChef from "../views/PrivateChef.vue";
const ProfileView = () => import(/* webpackChunkName: "Profile" */ '../views/Profile.vue');
const PrivateChef = () => import(/* webpackChunkName: "PrivateChef" */ '../views/PrivateChef.vue');
// import Privacy from "../views/Privacy.vue";
const Privacy = () => import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue');
// import Search from "../views/Search.vue";
// const Search = () => import(/* webpackChunkName: "search" */ '../views/Search.vue');
// import SearchOld from "../views/SearchOld.vue";
// import Book from "../views/Book.vue";
const Book = () => import(/* webpackChunkName: "book" */ '../views/Book.vue');
// import Checkout from "../views/Checkout.vue";
const Checkout = () => import(/* webpackChunkName: "book" */ '../views/Checkout.vue');
// import Dashboard from "../views/Dashboard";
const Dashboard = () => import(/* webpackChunkName: "account" */ '../views/Dashboard');
// import Account from "../views/Account";
const Account = () => import(/* webpackChunkName: "account" */ '../views/Account');
// import Admin from "../views/Admin";
const Admin = () => import(/* webpackChunkName: "admin" */ '../views/Admin');
// import OverviewAdmin from '../components/admin/Overview';
const OverviewAdmin = () => import(/* webpackChunkName: "admin" */ '../components/admin/Overview');
// import ChefsAdmin from '../components/admin/Chefs';
const ChefsAdmin = () => import(/* webpackChunkName: "admin" */ '../components/admin/Chefs');
// import ClientsAdmin from '../components/admin/Clients';
const ClientsAdmin = () => import(/* webpackChunkName: "admin" */ '../components/admin/Clients');
// import BookingsAdmin from '../components/common/Bookings';
const BookingsAdmin = () => import(/* webpackChunkName: "admin" */ '../components/common/Bookings');
// import Parameters from '../components/admin/Parameters';
const Parameters = () => import(/* webpackChunkName: "admin" */ '../components/admin/Parameters');
// import Details from '../components/common/Details';
const Details = () => import(/* webpackChunkName: "dashboard" */ '../components/common/Details');
// import Company from '../components/dashboard/Company';
const Company = () => import(/* webpackChunkName: "dashboard" */ '../components/dashboard/Company');
// import Profile from '../components/dashboard/Profile';
const Profile = () => import(/* webpackChunkName: "dashboard" */ '../components/dashboard/Profile');
// import Documents from '../components/dashboard/Documents';
const Documents = () => import(/* webpackChunkName: "dashboard" */ '../components/dashboard/Documents');
// import Photos from '../components/dashboard/Photos';
const Photos = () => import(/* webpackChunkName: "dashboard" */ '../components/dashboard/Photos');
// import Menus from '../components/dashboard/Menus';
const Menus = () => import(/* webpackChunkName: "dashboard" */ '../components/dashboard/Menus');
// import Overview from '../components/dashboard/Overview';
const Overview = () => import(/* webpackChunkName: "dashboard" */ '../components/dashboard/Overview');
// import OverviewAccount from '../components/account/OverviewAccount';
const OverviewAccount = () => import(/* webpackChunkName: "dashboard" */ '../components/account/OverviewAccount');
// import Bank from '../components/dashboard/Bank';
const Bank = () => import(/* webpackChunkName: "dashboard" */ '../components/dashboard/Bank');
const SignupChef = () => import(/* webpackChunkName: "SignupChef" */ '../views/SignupChef.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: "/:language_country?/search",
    name: "Search",
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue'),
    meta: {
      title: 'Private chef and catering service in Australia - Search',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: 'Search all the private chefs in your area. A private chef and catering service that brings restaurant quality in your home.'
        },
      ]
    },
  },
  // {
  //   path: "/searchOld",
  //   name: "SearchOld",
  //   component: SearchOld
  // },
  {
    path: "/:language_country?/book",
    name: "Book",
    component: Book,
    meta: { title: 'Book a Private chef and catering service in Australia' }
  },
  {
    path: "/:language_country?/checkout",
    name: "Checkout",
    component: Checkout,
    meta: { title: 'Checkout a Private chef and catering service in Australia' }
  },
  {
    path: "/:language_country?/faq",
    name: "FAQ",
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "help" */ '../views/Help.vue'),
    meta: {
      title: 'Private Chef FAQ — Your Questions Answered | Kootto',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: 'Got questions about booking a private chef? Find answers about how Kootto works, pricing, menus, dietary requirements, and what to expect on the day.'
        },
      ]
    }
  },
  {
    path: "/:language_country?/help",
    redirect: "/:language_country?/faq"
  },

  {
    path: "/:language_country?/terms",
    name: "Terms",
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "terms" */ '../views/Terms.vue'),
    meta: {
      title: 'Private chef and catering service in Australia - Terms',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: 'Read the terms and conditions for Kootto, Australia\'s leading private chef platform. Learn about our booking policies and service standards for catering.'
        },
      ]
    }
  },
  {
    path: "/:language_country?/privacy",
    name: "Privacy",
    component: Privacy,
    meta: {
      title: 'Private chef and catering service in Australia - Privacy',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: 'Your privacy matters. Learn how Kootto collects, uses, and protects your personal data to ensure a secure booking experience for our catering services.'

        },
      ]
    }
  },
  {
    path: "/:language_country?/admin/",
    name: "Admin",
    component: Admin,
    children: [
      {
        path: 'overview',
        name: "OverviewAdmin",
        component: OverviewAdmin,
        meta: { title: 'Kootto - Admin - Overview' }
      },
      {
        path: 'chefs',
        name: "Chefs",
        component: ChefsAdmin,
        meta: { title: 'Kootto - Admin - Chefs' }
      },
      {
        path: 'clients',
        name: "Clients",
        component: ClientsAdmin,
        meta: { title: 'Kootto - Admin - Clients' }
      },
      {
        path: 'bookings',
        name: "Bookings",
        component: BookingsAdmin,
        meta: { title: 'Kootto - Admin - Bookings' }
      },
      {
        path: 'parameters',
        name: "Parameters",
        component: Parameters,
        meta: { title: 'Kootto - Admin - Parameters' }
      },
      {
        path: 'potentialCustomers',
        name: "PotentialCustomers",
        component: () => import(/* webpackChunkName: "admin" */ '../components/admin/PotentialCustomers.vue'),
        meta: { title: 'Kootto - Admin - Potential Customers' }
      },
      {
        path: "tests",
        name: "Tests",
        component: () => import(/* webpackChunkName: "tests" */ '../components/admin/Tests.vue'),
        meta: { title: 'Kootto - Admin -Tests' }
      },
    ]
  },
  {
    path: "/:language_country?/:id?/dashboard/",
    name: "Dashboard",
    component: Dashboard,
    children: [
      {
        path: 'overview',
        name: "Overview",
        component: Overview,
        meta: { title: 'Kootto - Chef - Dashboard' }
      },
      {
        path: 'bookings',
        name: "BookingsDashboard",
        component: BookingsAdmin,
        meta: { title: 'Kootto - Chef - Bookings' }
      },
      {
        path: "details",
        name: "DashboardDetails",
        component: Details,
        meta: { title: 'Kootto - Chef - Details' }
      },
      {
        path: "profile",
        name: "DashboardProfile",
        component: Profile,
        meta: { title: 'Kootto - Chef - Profile' }
      },
      {
        path: "company",
        name: "Company",
        component: Company,
        meta: { title: 'Kootto - Chef - Company' }
      },
      {
        path: "bank",
        name: "Bank",
        component: Bank,
        meta: { title: 'Kootto - Chef - Bank' }
      },
      {
        path: "documents",
        name: "Documents",
        component: Documents,
        meta: { title: 'Kootto - Chef - Documents' }
      },
      {
        path: "photos",
        name: "Photos",
        component: Photos,
        meta: { title: 'Kootto - Chef - Photos' }
      },
      {
        path: "menus",
        name: "Menus",
        component: Menus,
        meta: { title: 'Kootto - Chef - Menus' }
      }
    ]
  },
  {
    path: "/:language_country?/:id?/account/",
    name: "Account",
    component: Account,
    children: [
      {
        path: 'overview',
        name: "OverviewAccount",
        component: OverviewAccount,
        meta: { title: 'Kootto - Client - Overview' }
      },
      {
        path: 'bookings',
        name: "BookingsAccount",
        component: BookingsAdmin,
        meta: { title: 'Kootto - Client - Bookings' }
      },
      {
        path: "details",
        name: "Details",
        component: Details,
        meta: { title: 'Kootto - Client - Details' }
      },
    ]
  },
  {
    path: "/:language_country?/signup",
    name: "Signup",
    component: SignupChef,
    meta: {
      title: 'Signup as a private chef in Australia',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: 'Join our private chef platform today and start taking your career to the next level. We can\'t wait to see what delicious creations you\'ll bring to the table!'
        },
      ]
    }
  },
  {
    path: "/:language_country?/private-chef/:city?/",
    name: "Private Chef",
    component: PrivateChef,
    meta: {
      // Dynamic title function that receives the route object
      title: (route) => {
        const citySlug = route.params.city;
        let cityName = 'Australia';

        if (citySlug) {
          cityName = citySlug
            .replace(/-/g, ' ')
            .replace(/\b\w/g, c => c.toUpperCase());
        }

        return `Private Chef ${cityName} - Book Your Personal Chef Today | Kootto`;
      },
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: (route) => {
            const citySlug = route.params.city;
            let cityName = 'Australia';
            let specificDesc = '';

            if (citySlug) {
              cityName = citySlug
                .replace(/-/g, ' ')
                .replace(/\b\w/g, c => c.toUpperCase());

              // City-specific descriptions for better SEO
              const cityDescriptions = {
                'Gold Coast': 'Hire a private chef in Gold Coast for dinner parties & events. Professional chefs serving Surfers Paradise, Broadbeach & beyond. Book now!',
                'Sydney': 'Hire a private chef in Sydney for luxury in-home dining. Professional chefs serving all Sydney suburbs. Perfect for dinner parties & events. Book today!',
                'Melbourne': 'Book a private chef in Melbourne for restaurant quality meals at home. Expert chefs serving all Melbourne areas. Ideal for dinner parties. Get a quote!',
                'Brisbane': 'Private chef services in Brisbane - Professional chefs for in-home dining & events. Serving all Brisbane suburbs. Book your personal chef now!',
                'Perth': 'Hire a private chef in Perth for exceptional in-home dining. Experienced chefs for dinner parties & events. Serving all Perth areas. Book today!',
                'Adelaide': 'Private chef Adelaide - Book professional chefs for home dining & special events. Serving all Adelaide suburbs. Get instant quotes!',
              };

              specificDesc = cityDescriptions[cityName] || `Hire a private chef in ${cityName} for dinner parties, events & in-home dining. Professional personal chefs serving all ${cityName} areas. Book now!`;
            } else {
              specificDesc = 'Private chef service that brings top restaurant quality to your home. No grocery shopping, cooking, or cleaning up, so you can fully enjoy your party.';
            }

            return specificDesc;
          }
        },
        {
          property: 'og:title',
          content: (route) => {
            const citySlug = route.params.city;
            let cityName = 'Australia';

            if (citySlug) {
              cityName = citySlug
                .replace(/-/g, ' ')
                .replace(/\b\w/g, c => c.toUpperCase());
            }

            return `Private Chef ${cityName} - Book Your Personal Chef | Kootto`;
          }
        }
      ]
    }
  },
  {
    path: "/:language_country?/personal-chef/:city?/",
    name: "Personal Chef",
    component: PrivateChef,
    meta: {
      // Dynamic title function that receives the route object
      title: (route) => {
        const citySlug = route.params.city;
        let cityName = 'Australia';

        if (citySlug) {
          cityName = citySlug
            .replace(/-/g, ' ')
            .replace(/\b\w/g, c => c.toUpperCase());
        }

        return `Personal Chef ${cityName} - Hire Your Private Chef Today | Kootto`;
      },
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: (route) => {
            const citySlug = route.params.city;
            let cityName = 'Australia';
            let specificDesc = '';

            if (citySlug) {
              cityName = citySlug
                .replace(/-/g, ' ')
                .replace(/\b\w/g, c => c.toUpperCase());

              // City-specific descriptions for better SEO
              const cityDescriptions = {
                'Gold Coast': 'Hire a personal chef in Gold Coast for catering & in-home cooking. Professional chefs serving all Gold Coast areas. Book your chef now!',
                'Sydney': 'Personal chef Sydney - Professional in-home cooking, catering & dining experiences. Serving all Sydney suburbs. Book your private chef today!',
                'Melbourne': 'Hire a personal chef in Melbourne for catering, dinner parties & in-home dining. Expert chefs across Melbourne. Get a quote now!',
                'Brisbane': 'Personal chef Brisbane - In-home cooking, catering & dining experiences. Professional chefs serving all Brisbane areas. Book today!',
                'Perth': 'Hire a personal chef in Perth for catering, dinner parties & in-home dining. Experienced chefs across Perth. Book your chef now!',
                'Adelaide': 'Personal chef Adelaide - Professional in-home cooking and catering services. Serving all Adelaide suburbs. Book your chef today!',
              };

              specificDesc = cityDescriptions[cityName] || `Hire a personal chef in ${cityName} for catering, in-home cooking & dining experiences. Professional chefs serving all ${cityName} areas. Book now!`;
            } else {
              specificDesc = 'Personal chef service for catering, in-home cooking and dining experiences. Professional chefs bring restaurant quality to your home.';
            }

            return specificDesc;
          }
        },
        {
          property: 'og:title',
          content: (route) => {
            const citySlug = route.params.city;
            let cityName = 'Australia';

            if (citySlug) {
              cityName = citySlug
                .replace(/-/g, ' ')
                .replace(/\b\w/g, c => c.toUpperCase());
            }

            return `Personal Chef ${cityName} - Hire Your Private Chef | Kootto`;
          }
        }
      ]
    }
  },
  {
    path: "/:language_country?/profile/:name?/",
    name: "Profile",
    component: ProfileView,
    meta: {
      title: (route) => {
        const name = route.params.name;
        if (name) {
          const capitalized = name.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
          return `Private Chef ${capitalized} - Profile & Menus | Kootto`;
        }
        return 'Private Chef Profile | Kootto';
      },
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: (route) => {
            const name = route.params.name;
            if (name) {
              const capitalized = name.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
              return `Explore the profile and menus of Private Chef ${capitalized}. Book a unique in-home dining experience with professional chefs on Kootto.`;
            }
            return 'Explore private chef profiles and book unique in-home dining experiences with professional chefs on Kootto.';
          }
        }
      ]
    }
  },
  {
    path: "/:language_country?/blog",
    name: "BlogList",
    component: () => import(/* webpackChunkName: "blog" */ '../views/BlogList.vue'),
    meta: {
      title: 'Blog - Private Chef Tips & Inspiration | Kootto',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: "Expert tips, stories and culinary inspiration for your next private dining experience. Discover how Kootto's private chefs are transforming in-home catering.",
        },
      ],
    },
  },
  {
    path: "/:language_country?/blog/why-we-built-kootto",
    name: "BlogWhyWeBuiltKootto",
    component: () => import(/* webpackChunkName: "blog" */ '../views/blog/WhyWeBuiltKootto.vue'),
    meta: {
      title: "Why We Built Kootto: Australia's Private Chef Marketplace",
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: "The story of Kootto: Two French expats, a shared love of good food, and the mission to bring private chefs to homes across Australia.",
        },
      ],
    },
  },
  {
    path: "/:language_country?/blog/what-is-a-private-chef",
    name: "BlogWhatIsAPrivateChef",
    component: () => import(/* webpackChunkName: "blog" */ '../views/blog/WhatIsAPrivateChef.vue'),
    meta: {
      title: 'What Is a Private Chef and Do You Need One? | Kootto Blog',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: "What does a private chef actually do? We break down the role, how they differ from catering services, and if they're right for your next event.",
        },
      ],
    },
  },
  {
    path: "/:language_country?/blog/how-to-plan-a-dinner-party",
    name: "BlogHowToPlanADinnerParty",
    component: () => import(/* webpackChunkName: "blog" */ '../views/blog/HowToPlanADinnerParty.vue'),
    meta: {
      title: 'How to Plan the Perfect Dinner Party | Kootto Blog',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: "From setting the guest list to choosing the right menu, planning a dinner party can feel overwhelming. Here's a step-by-step guide to make it effortless.",
        },
      ],
    },
  },
  {
    path: "/:language_country?/blog/top-cuisines-for-private-dining",
    name: "BlogTopCuisinesForPrivateDining",
    component: () => import(/* webpackChunkName: "blog" */ '../views/blog/TopCuisinesForPrivateDining.vue'),
    meta: {
      title: 'Top 5 Cuisines for Your Private Dining Experience | Kootto',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: "Not sure what cuisine to choose? We've rounded up the five most popular choices our clients love — and why each works beautifully in a home setting.",
        },
      ],
    },
  },
  {
    path: "/:language_country?/contact",
    name: "Contact",
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
    meta: {
      title: 'Contact Us | Kootto',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: 'Have questions about booking a private chef? Get in touch with the Kootto team today through our contact form or connect with us on our social media channels.'
        },
      ]
    }
  },
  // /:pathMatch(.*)
  // { path: '*', redirect: '/' },
  {
    path: "/:language_country?/:pathMatch(.*)",
    // path: "/:pathMatch(.*)",
    name: "Home",
    component: Home,
    meta: {
      title: 'Private chef and catering service in Australia - Kootto',
      metaTags: [
        {
          name: 'description',
          property: 'og:description',
          content: 'Private chef service that brings top restaurant quality to your home. No grocery shopping, cooking, or cleaning up, so you can fully enjoy your party.'
        },
      ]
    }
  },

  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

// const selectedLanguage = localStorage.getItem('selectedLanguage');
// const selectedLanguageResult = selectedLanguage ? JSON.parse(selectedLanguage).value.toLowerCase() : 'en';

// const selectedCountry = localStorage.getItem('selectedCountry');
// const selectedCountryResult = selectedCountry ? JSON.parse(selectedCountry).flag.toLowerCase() : 'au';

// const language_country= selectedLanguageResult+"-"+selectedCountryResult;

const router = new VueRouter({
  mode: 'history',
  routes,
  base: '/',
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      document.getElementById('app').scrollIntoView();
    }
  }
});

export default router;
